export default {
  view: 'supplier.view_servicecategory',
  add: 'supplier.add_servicecategory',
  change: 'supplier.change_servicecategory',
  delete: 'supplier.delete_servicecategory',
  export: 'supplier.export_servicecategory',
  import: 'supplier.import_servicecategory',
};
